/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TestEmailForwardingRequest
 */
export interface TestEmailForwardingRequest {
    /**
     * Optional mailbox to test (uses the stored one if not provided)
     */
    targetMailbox?: string;
}

/**
 * Check if a given object implements the TestEmailForwardingRequest interface.
 */
export function instanceOfTestEmailForwardingRequest(value: object): value is TestEmailForwardingRequest {
    return true;
}

export function TestEmailForwardingRequestFromJSON(json: any): TestEmailForwardingRequest {
    return TestEmailForwardingRequestFromJSONTyped(json, false);
}

export function TestEmailForwardingRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TestEmailForwardingRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'targetMailbox': json['targetMailbox'] == null ? undefined : json['targetMailbox'],
    };
}

export function TestEmailForwardingRequestToJSON(json: any): TestEmailForwardingRequest {
    return TestEmailForwardingRequestToJSONTyped(json, false);
}

export function TestEmailForwardingRequestToJSONTyped(value?: TestEmailForwardingRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'targetMailbox': value['targetMailbox'],
    };
}

